import React from "react";

const Homesection3Card2 = (props) => {
  return (
    <div className="container mt-8 h-80 w-full lg:w-96">
      <img className="h-96 w-full lg:h-80 lg:w-full" src={props.image} alt="" />
      <div className="overlay opacity-40">
        <div className="text font-bold text-black">{props.title}</div>
      </div>
    </div>
  );
};

export default Homesection3Card2;
